const normalizeFamily = (value) =>
  String(value || "")
    .normalize("NFKD")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toLowerCase();

const getCatalogFamily = (entry) =>
  typeof entry === "string" ? entry : entry && entry.family;

const makeGoogleUrl = (fontFamily) =>
  `https://fonts.google.com/specimen/${fontFamily.replace(/ /g, "+")}`;

const makeAdobeUrl = (fontFamily) =>
  `https://fonts.adobe.com/fonts/${fontFamily
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")}`;

export function getKnownFontFamilies(catalog) {
  return (catalog || []).map(getCatalogFamily).filter(Boolean);
}

export function buildFontLinks(fonts, catalog, site) {
  const catalogFamilies = getKnownFontFamilies(catalog);
  const catalogByNormalizedName = new Map(
    catalogFamilies.map((family) => [normalizeFamily(family), family]),
  );

  return (fonts || []).map((font) => {
    const catalogFamily = catalogByNormalizedName.get(
      normalizeFamily(font.fontFamily),
    );

    return {
      ...font,
      link: catalogFamily
        ? site === "adobe"
          ? makeAdobeUrl(catalogFamily)
          : makeGoogleUrl(catalogFamily)
        : "",
    };
  });
}

export function generateFontText(fontLinks) {
  if (!fontLinks || fontLinks.length === 0) {
    return "No fonts required\n";
  }

  const lines = ["Download the fonts used here:", ""];

  fontLinks.forEach(({ fontFamily, fontStyles, link }) => {
    const styles =
      Array.isArray(fontStyles) && fontStyles.length
        ? fontStyles.join(", ")
        : "Styles not specified";
    lines.push(
      `${fontFamily}: used styles: ${styles}: ${link || "url not found"}`,
    );
  });

  return `${lines.join("\n")}\n`;
}

export function makeFontResultMessage(fontLinks) {
  const found = fontLinks.filter((font) => font.link);
  const missing = fontLinks.filter((font) => !font.link);

  if (!fontLinks.length) {
    return "No fonts required";
  }

  if (!missing.length) {
    return `All font found: ${found.length}`;
  }

  const missingNames = missing.map((font) => font.fontFamily).join(",\n");
  if (found.length) {
    return `Font found: ${found.length}.\n\nFont not found: ${missingNames}`;
  }

  return `Font URL not found:\n\n${missingNames}`;
}
